import { processInternalTransferExport } from 'commons/service/bank/internalTransfer'
import { InternalTransfersExport } from 'commons/types/DTO/bank'
import { WriteHook, useMutationManager } from 'state-manager'

export const useProcessInternalTransferExport: WriteHook<number | undefined, InternalTransfersExport> = (opts) =>
  useMutationManager(processInternalTransferExport, opts)
